export default __webpack_public_path__ + "9c549f14ea0bab847615bd51e416dc2a.png";